import React, { useState } from 'react';

import PhoneConfirmation from 'ggApp/modules/auth/v3/components/forms/PhoneConfirmation';

import { PhoneConfirmationWrapper } from './styles';

const PhoneVerification = ({ current, send, stepData: { onSubmit, ...stepData } }) => {
    const [inputValue, setInputValue] = useState('');

    const phoneLastDigits = current?.context?.phoneVerificationPending?.phoneLastDigits ?? null;
    const requestPayload = current?.context?.phoneVerificationPending?.requestPayload ?? null;
    const phoneVerificationConfirmError = current?.context?.phoneVerificationConfirmError ?? null;

    const handleChange = ({ target: { value } }) => {
        setInputValue(value);
        const code = value?.toString() ?? '';

        if (code.length === 4) {
            send('CONFIRM', {
                ...requestPayload,
                code,
            });
        }
    };

    const secondaryAction = () => send('HELP');

    return (
        <PhoneConfirmationWrapper>
            <PhoneConfirmation
                stepData={stepData}
                onSubmit={onSubmit}
                onSecondaryAction={secondaryAction}
                hintValues={{ phoneLastDigits }}
                onChange={handleChange}
                value={inputValue}
                error={phoneVerificationConfirmError}
                helplink
                address2FAStyle
            />
        </PhoneConfirmationWrapper>
    );
};

export default PhoneVerification;
